var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"d-inline-flex justify-content-center",class:_vm.large && 'text-lg font-weight-normal',attrs:{"pill":"","variant":_vm.variant}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }